module.exports = __webpack_public_path__ + "img/img-cate2.7959bdf0.webp";